module.exports = __webpack_public_path__ + "img/sankaku_50_red.78ee8ca6.png";